const fn = {
  init: () => {
    const els = document.querySelectorAll('.scholarship-print')
    els.forEach((el) => {
      el.addEventListener('click', function () {
        const blocks = document.querySelectorAll('.scholarship-opportunity')
        blocks.forEach((block) => {
          block.classList.remove('print-me')
        })
        var parent = this.closest('.scholarship-opportunity')
        parent.classList.add('print-me')
        window.print()
      })
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
